<template>
  <div class="db-view">
    <div class="header">
      <div class="flex pr pl">
        <div class="bd" style="z-index: 1;">
          <div class="flex mt-sm border-top">
            <div class="hd header-diagonal header-diagonal-left"></div>
            <div style="height:10px;" class="bd border-bottom backgroud-shadow"></div>
          </div>
          <div class="flex" style="position: relative;">
            <div class="bd mt pl">
              <img src="@/assets/puyou.png" width="120px" />
            </div>
            <div class="ft">
              <img
                src="@/assets/left-ornament.png"
                class="mt-xs"
                width="160px"
                style="margin-right: -15px;"
              />
            </div>
          </div>
        </div>
        <div class="flex hd">
          <div class="bd flex backgroud-shadow border-top mt-sm">
            <div class="hd diagonal diagonal-left mt-sm"></div>
            <h1
              class="text-center font-36 bd title-box border-bottom"
              style="margin: 0;"
              :contenteditable="true"
              @blur="handleBlur($event)"
            >{{$store.state.godStore.god.dashboard_title}}</h1>
            <div class="ft diagonal diagonal-right mt-sm"></div>
          </div>
        </div>
        <div class="bd">
          <div class="flex mt-sm border-top">
            <div style="width:100%;height:10px;" class="border-bottom backgroud-shadow"></div>
            <div class="ft header-diagonal header-diagonal-right"></div>
          </div>
          <div class="flex" style="position: relative;">
            <div class="bd">
              <img
                src="@/assets/right-ornament.png"
                class="mt-xs"
                width="160px"
                style="margin-left: -15px;"
              />
            </div>
            <div class="ft font-20 pt pr">
              <div>{{date | parseTime('{y}年{m}月{d}日')}}</div>
              <div>{{date | parseTime('{h}:{i}:{s}')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="view-body pl-sm pr-sm" style="margin-top: 25px;">
      <el-row :gutter="20">
        <el-col :span="6">
          <left-content ref="leftContent" />
        </el-col>
        <el-col :span="12">
          <center-content />
        </el-col>

        <el-col :span="6">
          <right-content ref="rightContent" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import store from "@/store/store";
import { mapState, mapGetters } from "vuex";

export default {
  name: "DbEquip",
  components: {
    rightContent: () => import("./components/rightContent.vue"),
    centerContent: () => import("./components/centerContent.vue"),
    leftContent: () => import("./components/leftContent.vue"),
  },
  data() {
    return {
      index: 0,
      date: new Date(),
      timeInterval: null,
      updateInterval: null,
    };
  },

  computed: {
    ...mapState({
      pindex(state) {
        return state.equipStore.pindex;
      },
    }),
  },
  beforeCreate() {
    store.dispatch("getAllEquips");
  },
  created() {
    var that = this;
    this.timeInterval = setInterval(() => {
      this.date = new Date();
    }, 1000);
    this.updateInterval = setInterval(() => {
      store.dispatch("setPindex", that.pindex + 1);
    }, 60000);
    this.getInterval = setInterval(() => {
      store.dispatch("getAllEquips");
      this.$refs.rightContent.fetchData();
      this.$refs.leftContent.fetchData();
    }, 10000);
  },
  beforeDestroy() {
    clearInterval(this.timeInterval);
    clearInterval(this.getInterval);
    clearInterval(this.updateInterval);
  },
  methods: {
    handleBlur(e) {
      this.$store.dispatch("setDbTitle", {
        dashboard_title: e.target.innerText,
      });
    },
  },
};
</script>

<style lang="scss">
.db-view {
  position: fixed;
  right: 0;
  top: 0;
  background-color: rgba(21, 21, 21, 0.9);
  background-image: url(../../assets/mes-bg-image.jpg);
  background-repeat: round;
  height: 100vh;
  width: calc(100% - 60px);
  color: #fff;
  .border-color {
    margin: 0;
    border-top-width: 0;
    border-color: rgba(7, 193, 96, 1);
  }

  .title-box {
    height: 70px;
    position: relative;
    padding: 10px 15px;
    // box-shadow: 0px 0px 6px 0px rgba(6, 121, 61, 100);
  }

  .border-top {
    border-top: 1px solid #07c160;
  }
  .border-bottom {
    border-bottom: 1px solid #07c160;
  }

  .view-body {
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }
  .content-box {
    position: relative;
    background: linear-gradient(to left, #07c160, #07c160) left top no-repeat,
      linear-gradient(to bottom, #07c160, #07c160) left top no-repeat,
      linear-gradient(to left, #07c160, #07c160) right top no-repeat,
      linear-gradient(to bottom, #07c160, #07c160) right top no-repeat,
      linear-gradient(to left, #07c160, #07c160) left bottom no-repeat,
      linear-gradient(to bottom, #07c160, #07c160) left bottom no-repeat,
      linear-gradient(to left, #07c160, #07c160) right bottom no-repeat,
      linear-gradient(to left, #07c160, #07c160) right bottom no-repeat;
    background-size: 2px 20px, 20px 2px, 2px 20px, 20px 2px;
    height: calc(100vh - 132px);
    padding: 1px;
    box-sizing: border-box;
  }
  .outer {
    box-shadow: 0px 2px 6px 0px rgba(7, 193, 96, 40);
    height: 100%;
    box-sizing: border-box;
    padding: 8px 10px;
    .title {
      color: #fff;
      font-weight: bold;
      font-size: 20px;
      display: flex;
      justify-content: space-between;
    }
  }

  .backgroud-shadow {
    background: linear-gradient(
      180deg,
      rgba(7, 193, 96, 0.1) 0%,
      rgba(7, 193, 96, 0) 100%
    );
  }

  .header-diagonal {
    width: 10px;
    height: 10px;
  }

  .header-diagonal-left {
    position: relative;
    background: linear-gradient(
      45deg,
      transparent 49.5%,
      #07c160 49.5%,
      #07c160 50.5%,
      transparent 50.5%
    );
    &::before {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      border: 5px solid transparent;
      border-left: 4px solid #242b35;
      border-bottom: 4px solid #242b35;
    }
  }

  .header-diagonal-right {
    position: relative;
    background: linear-gradient(
      -45deg,
      transparent 49.5%,
      #07c160 49.5%,
      #07c160 50.5%,
      transparent 50.5%
    );
    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      content: "";
      border: 5px solid transparent;
      border-right: 4px solid #242b35;
      border-bottom: 4px solid #242b35;
    }
  }

  .diagonal {
    width: 60px;
    height: 60px;
  }

  .diagonal-left {
    position: relative;
    background: linear-gradient(
      45deg,
      transparent 49.5%,
      #07c160 49.5%,
      #07c160 50.5%,
      transparent 50.5%
    );
    &::before {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      border: 30px solid transparent;
      border-left: 29px solid #242b35;
      border-bottom: 29px solid #242b35;
    }
  }
  .diagonal-right {
    position: relative;
    background: linear-gradient(
      -45deg,
      transparent 49.5%,
      #07c160 49.5%,
      #07c160 50.5%,
      transparent 50.5%
    );
    &::before {
      position: absolute;
      right: 0;
      bottom: 0;
      content: "";
      border: 30px solid transparent;
      border-right: 29px solid #242b35;
      border-bottom: 29px solid #242b35;
    }
  }
}
</style>